<template
>
  <div class="boss-page task-manage">
    <van-nav-bar
      title="重大/临时任务"
      left-arrow
      @click-left="$router.back()"
      right-text="下发任务"
      @click-right="showForm = !showForm"
    />
    <section v-if="showForm" class="task-form">
      <h2>下发绩效任务</h2>
      <label
      >任务类型
        <div class="segments">
          <button
            :class="{ active: form.assignmentType === 'TEMPORARY' }"
            @click="
              form.assignmentType = 'TEMPORARY';
              form.performanceWeight = 10;
            "
          >
            临时任务
          </button
          >
          <button
            :class="{ active: form.assignmentType === 'MAJOR' }"
            @click="
              form.assignmentType = 'MAJOR';
              form.performanceWeight = 20;
            "
          >
            重大任务
          </button>
        </div>
      </label
      >
      <label
      >指定员工<select v-model="form.assigneeEmployeeId"
      >
        <option disabled value="">请选择员工
        </option
        >
        <option
          v-for="item in employees"
          :key="item.employeeId"
          :value="item.employeeId"
        >{{ item.employeeName }} · {{ item.departmentName }} ·
          {{ item.positionName }}
        </option
        >
      </select
      ></label
      >
      <label
      >任务名称<input
        v-model.trim="form.title"
        maxlength="200"
        placeholder="简明描述任务目标"
      /></label>
      <label
      >任务内容<textarea
        v-model.trim="form.content"
        maxlength="3000"
        placeholder="说明工作内容、范围和关键要求"
      /></label>
      <label
      >验收标准<textarea
        v-model.trim="form.acceptanceCriteria"
        maxlength="2000"
        placeholder="写明可检查的成果和完成口径"
      /></label>
      <div class="time-grid">
        <label
        >开始时间<input v-model="form.startAt" type="datetime-local"/></label
        ><label
      >截止时间<input v-model="form.dueAt" type="datetime-local"
      /></label>
      </div>
      <label
      >绩效权重（1%–30%）<input
        v-model.number="form.performanceWeight"
        type="number"
        min="1"
        max="30"
      /></label>
      <p class="formula">
        到期月份综合分 = 岗位绩效 × 剩余权重 + 任务验收分 ×
        任务权重；同月任务总权重最多30%。
      </p>
      <p v-if="isAcceptance" class="acceptance-hint">
        <van-icon name="info-o"/>
        当前为功能验收身份。下发后请在“我的 →
        员工岗位”切换到相同岗位查看；恢复真实身份不会显示验收任务。
      </p>
      <van-button
        block
        icon="passed"
        color="#D32F2F"
        :loading="saving"
        style="height:.88rem;margin-top:.08rem;border-radius:.14rem;box-shadow:0 .1rem .24rem rgba(211,47,47,.22);font-size:.31rem;font-weight:500;letter-spacing:0"
        @click="create"
      >确认下发
      </van-button
      >
    </section>
    <section class="month">
      <button @click="change(-1)">
        <van-icon name="arrow-left"/>
      </button
      >
      <b>{{ month.replace("-", " 年 ") }} 月</b
      >
      <button @click="change(1)">
        <van-icon name="arrow"/>
      </button>
    </section>
    <main>
      <div class="status-filter">
        <button
          v-for="item in filters"
          :key="item.value"
          :class="{ active: filter === item.value }"
          @click="filter = item.value"
        >
          {{ item.label }}
        </button>
      </div>
      <article
        v-for="item in filtered"
        :key="item.id"
        class="task-card"
        @click="select(item)"
      >
        <header>
          <em :class="item.assignmentType.toLowerCase()">{{
              item.assignmentTypeLabel
            }}</em
          ><span :class="['status', item.status.toLowerCase()]">{{
            status(item.status)
          }}</span>
        </header>
        <h3>{{ item.title }}</h3>
        <p>
          {{ item.assigneeName }} · {{ item.departmentName }} ·
          {{ item.positionName }}
        </p>
        <footer>
          <span>截止 {{ date(item.dueAt) }}</span
          ><b>权重 {{ item.performanceWeight }}%</b>
        </footer>
      </article>
      <van-empty v-if="!filtered.length" description="本月暂无任务"/>
    </main>
    <van-popup v-model="showDetail" position="bottom" round class="detail-sheet"
    >
      <div v-if="current">
        <header>
          <div>
            <em>{{ current.assignmentTypeLabel }}</em>
            <h2>{{ current.title }}</h2>
          </div>
          <button @click="showDetail = false">
            <van-icon name="cross"/>
          </button>
        </header>
        <dl>
          <dt>执行员工</dt>
          <dd>
            {{ current.assigneeName }} · {{ current.departmentName }} ·
            {{ current.positionName }}
          </dd>
          <dt>任务内容</dt>
          <dd>{{ current.content }}</dd>
          <dt>验收标准</dt>
          <dd>{{ current.acceptanceCriteria }}</dd>
          <dt>执行时间</dt>
          <dd>{{ date(current.startAt) }} 至 {{ date(current.dueAt) }}</dd>
          <dt>绩效权重</dt>
          <dd>{{ current.performanceWeight }}%</dd>
          <template v-if="current.completionNote"
          >
            <dt>完成说明</dt>
            <dd>{{ current.completionNote }}</dd>
          </template
          >
          <template v-if="current.evidenceReference"
          >
            <dt>成果凭证</dt>
            <dd>{{ current.evidenceReference }}</dd>
          </template
          >
        </dl>
        <div v-if="current.status === 'SUBMITTED'" class="review">
          <label
          >任务评分<input
            v-model.number="review.score"
            type="number"
            min="0"
            max="100"/></label
          ><label
        >验收意见<textarea
          v-model.trim="review.note"
          placeholder="说明评分依据或退回原因"
        /></label>
          <div>
            <van-button
              class="review-action"
              plain
              color="#d85b5b"
              @click="submitReview('RETURN')"
            >退回重做
            </van-button
            >
            <van-button
              class="review-action primary"
              color="#B71C1C"
              @click="submitReview('VERIFY')"
            >验收通过
            </van-button
            >
          </div>
        </div>
        <section
          v-if="current.reviewNote"
          :class="['review-result', { returned: current.status === 'RETURNED' }]"
        >
          <header>
            <van-icon
              :name="current.status === 'RETURNED' ? 'replay' : 'passed'"
            />
            <div>
              <h3>{{ current.status === "RETURNED" ? "已退回重做" : "验收已完成" }}</h3>
              <span v-if="current.verifiedAt">{{ date(current.verifiedAt) }}</span>
            </div>
            <strong v-if="current.score != null"
            >{{ current.score }}<small>分</small></strong
            >
          </header>
          <div class="result-note">
            <b>验收意见</b>
            <p>{{ current.reviewNote }}</p>
          </div>
        </section>
      </div>
    </van-popup
    >
  </div>
</template
>
<script>
/**
 * Boss 重大/临时任务：下发、按月列表、验收通过/退回。
 * 功能验收身份（CoreAcceptanceRole=BOSS）下发后需切员工岗位才能看到任务。
 */
import coreapi from "@/utils/coreapi";

export default {
  data() {
    const d = new Date(),
      tomorrow = new Date(d.getTime() + 86400000);
    const input = v => {
      const x = new Date(v.getTime() - v.getTimezoneOffset() * 60000);
      return x.toISOString().slice(0, 16);
    };
    return {
      month:
        this.$route.query.month ||
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`,
      employees: [],
      tasks: [],
      showForm: false,
      saving: false,
      filter: "ALL",
      filters: [
        {label: "全部", value: "ALL"},
        {label: "待执行", value: "ASSIGNED"},
        {label: "进行中", value: "IN_PROGRESS"},
        {label: "待验收", value: "SUBMITTED"},
        {label: "已完成", value: "VERIFIED"}
      ],
      form: {
        assignmentType: "TEMPORARY",
        assigneeEmployeeId: "",
        title: "",
        content: "",
        acceptanceCriteria: "",
        startAt: input(d),
        dueAt: input(tomorrow),
        performanceWeight: 10
      },
      showDetail: false,
      current: null,
      review: {score: 100, note: ""}
    };
  },
  computed: {
    isAcceptance() {
      return localStorage.getItem("CoreAcceptanceRole") === "BOSS";
    },
    filtered() {
      return this.filter === "ALL"
        ? this.tasks
        : this.tasks.filter(v => v.status === this.filter);
    }
  },
  mounted() {
    Promise.all([coreapi.bossEmployees(), this.load()])
      .then(v => (this.employees = v[0]))
      .catch(e => this.$toast.fail(e.message));
  },
  methods: {
    async load() {
      this.tasks = await coreapi.bossTasks(this.month);
    },
    /** 临时任务默认 10% 权重，重大任务 20%；同月任务总权重上限 30% 由后端校验 */
    async create() {
      if (
        !this.form.assigneeEmployeeId ||
        !this.form.title ||
        !this.form.content ||
        !this.form.acceptanceCriteria
      )
        return this.$toast("请完整填写任务信息");
      this.saving = true;
      try {
        await coreapi.createBossTask({
          ...this.form,
          assigneeEmployeeId: Number(this.form.assigneeEmployeeId),
          startAt: new Date(this.form.startAt).toISOString(),
          dueAt: new Date(this.form.dueAt).toISOString()
        });
        if (this.isAcceptance) {
          const employee = this.employees.find(
            item => Number(item.employeeId) === Number(this.form.assigneeEmployeeId)
          );
          await this.$dialog.alert({
            title: "任务已下发",
            message: `已发送给${employee ? employee.employeeName : "验收员工"}。请前往“我的 → 员工岗位”切换到对应岗位查看，不要恢复真实身份。`,
            confirmButtonText: "我知道了",
            confirmButtonColor: "#B71C1C"
          });
        } else {
          this.$toast.success("任务已下发");
        }
        this.showForm = false;
        await this.load();
      } catch (e) {
        this.$toast.fail(e.message);
      } finally {
        this.saving = false;
      }
    },
    change(n) {
      const p = this.month.split("-"),
        d = new Date(+p[0], +p[1] - 1 + n, 1);
      this.month = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}`;
      this.load().catch(e => this.$toast.fail(e.message));
    },
    select(v) {
      this.current = v;
      this.review = {
        score: v.score == null ? 100 : v.score,
        note: v.reviewNote || ""
      };
      this.showDetail = true;
    },
    async submitReview(action) {
      if (!this.review.note) return this.$toast("请填写验收意见");
      try {
        this.current = await coreapi.reviewBossTask(this.current.id, {
          action,
          score: action === "VERIFY" ? Number(this.review.score) : null,
          note: this.review.note
        });
        this.$toast.success(action === "VERIFY" ? "验收完成" : "已退回员工");
        await this.load();
      } catch (e) {
        this.$toast.fail(e.message);
      }
    },
    date(v) {
      return v
        ? new Date(v).toLocaleString("zh-CN", {
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit"
        })
        : "--";
    },
    status(v) {
      return (
        {
          ASSIGNED: "待执行",
          IN_PROGRESS: "进行中",
          SUBMITTED: "待验收",
          VERIFIED: "已完成",
          RETURNED: "已退回"
        }[v] || v
      );
    }
  }
};
</script>
<style lang="less" scoped>
@import './boss.less';

.task-form {
  margin: .28rem;
  padding: .34rem;
  background: #fff;
  border-radius: .24rem;
  box-shadow: 0 .08rem .3rem rgba(211, 47, 47, .1)
}

.task-form h2 {
  margin-bottom: .24rem;
  font-size: .38rem
}

.task-form label, .review label {
  display: block;
  margin-top: .2rem;
  color: #55586b;
  font-size: .27rem
}

.task-form input, .task-form select, .task-form textarea, .review input, .review textarea {
  width: 100%;
  margin-top: .1rem;
  padding: .2rem;
  border: 1PX solid #e2e3ec;
  border-radius: .12rem;
  background: #fafaff;
  font-size: .28rem;
  box-sizing: border-box
}

.task-form textarea {
  height: 1.35rem;
  resize: none
}

.segments {
  margin-top: .1rem;
  display: grid;
  grid-template-columns:1fr 1fr
}

.segments button {
  height: .7rem;
  border: 1PX solid #dfe0ee;
  color: #73768a
}

.segments button:first-child {
  border-radius: .12rem 0 0 .12rem
}

.segments button:last-child {
  border-radius: 0 .12rem .12rem 0
}

.segments button.active, .status-filter button.active {
  color: #fff;
  border-color: @color;
  background: @color
}

.time-grid {
  display: grid;
  grid-template-columns:1fr 1fr;
  gap: .14rem
}

.formula {
  margin: .22rem 0;
  color: #85889a;
  font-size: .23rem;
  line-height: 1.5
}

.status-filter {
  display: flex;
  gap: .1rem;
  margin-bottom: .2rem;
  overflow: auto
}

.status-filter button {
  flex: 0 0 auto;
  padding: .12rem .2rem;
  color: #777b90;
  border-radius: .28rem;
  background: #fff
}

.task-card {
  cursor: pointer
}

.task-card header, .task-card footer {
  display: flex;
  align-items: center;
  justify-content: space-between
}

.task-card em, .detail-sheet em {
  padding: .06rem .13rem;
  color: @color;
  font-size: .22rem;
  font-style: normal;
  background: #fff5f5;
  border-radius: .24rem
}

.task-card em.major {
  color: #a66b10;
  background: #fff3df
}

.task-card h3 {
  margin: .18rem 0 .08rem;
  font-size: .33rem
}

.task-card p, .task-card footer {
  color: #898c9e;
  font-size: .24rem
}

.task-card footer {
  margin-top: .18rem
}

.task-card footer b {
  color: @color
}

.status {
  font-size: .23rem
}

.status.submitted {
  color: #e48b18
}

.status.verified {
  color: #2d9b61
}

.status.returned {
  color: #D32F2F
}

.detail-sheet {
  max-height: 86vh;
  padding: .36rem;
  box-sizing: border-box
}

.detail-sheet > div > header {
  display: flex;
  justify-content: space-between
}

.detail-sheet h2 {
  margin-top: .12rem;
  font-size: .4rem
}

.detail-sheet header button {
  font-size: .38rem
}

.detail-sheet dl {
  margin-top: .25rem
}

.detail-sheet dt {
  margin-top: .2rem;
  color: #9093a3;
  font-size: .24rem
}

.detail-sheet dd {
  margin: .08rem 0 0;
  color: #34364a;
  font-size: .29rem;
  line-height: 1.55;
  white-space: pre-wrap
}

.review textarea {
  height: 1.2rem
}

.review > div {
  margin-top: .24rem;
  display: grid;
  grid-template-columns:1fr 1fr;
  gap: .16rem
}

.review-action {
  height: .82rem;
  border-radius: .14rem;
  font-size: .29rem;
  font-weight: 500;
  letter-spacing: 0
}

.review-action.primary {
  box-shadow: 0 .08rem .2rem rgba(78, 84, 199, .2)
}

.review-result {
  margin-top: .28rem;
  padding: .26rem;
  border: 1PX solid #e2e4fa;
  border-radius: .18rem;
  background: #f7f7ff
}

.review-result > header {
  display: flex;
  align-items: center
}

.review-result > header > .van-icon {
  width: .68rem;
  height: .68rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 .68rem;
  margin-right: .18rem;
  color: #fff;
  border-radius: 50%;
  background: #B71C1C;
  font-size: .36rem
}

.review-result > header > div {
  min-width: 0;
  flex: 1
}

.review-result h3 {
  color: #34364a;
  font-size: .31rem
}

.review-result header span {
  display: block;
  margin-top: .04rem;
  color: #9295a7;
  font-size: .22rem
}

.review-result strong {
  color: #B71C1C;
  font-size: .48rem;
  line-height: 1
}

.review-result strong small {
  margin-left: .04rem;
  font-size: .22rem;
  font-weight: 400
}

.result-note {
  margin-top: .22rem;
  padding-top: .2rem;
  border-top: 1PX solid #e3e4ef
}

.result-note b {
  display: block;
  color: #55586b;
  font-size: .25rem
}

.result-note p {
  margin-top: .08rem;
  color: #34364a;
  font-size: .28rem;
  line-height: 1.6;
  white-space: pre-wrap
}

.review-result.returned {
  border-color: #f0dcdc;
  background: #fff7f7
}

.review-result.returned > header > .van-icon {
  background: #d85b5b
}

.review-result.returned h3 {
  color: #b84d4d
}

.acceptance-hint {
  margin: .02rem 0 .22rem;
  padding: .18rem .2rem;
  color: #676b83;
  background: #f2f3ff;
  border-left: .06rem solid #D32F2F;
  border-radius: .1rem;
  font-size: .24rem;
  line-height: 1.55
}

.acceptance-hint .van-icon {
  margin-right: .08rem;
  color: #D32F2F
}
</style>



// WEBPACK FOOTER //
// src/views/boss/Tasks.vue